<template>

  <!-- <div class="col-md-12" style="padding: 10px;">
    <div class="card card-map" id="card-content">
      <div class="card-body"> -->

        <div id="helpId">

   <iframe id="myframe"
     width="100%"
     height="100%"
     :src="url"
   >
   </iframe>

        </div>

      <!-- </div>
    </div>
  </div> -->

</template>
<script>

import { Card } from "src/components/UIComponents";
import { ConfigParams } from "../../../config.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      url: ''
    };
  },
  methods: {

    handleResize() {
      let navbarHeight = document.getElementById("navbar").offsetHeight;
      let windowHeight = window.innerHeight;
      let contentHeight = windowHeight  - navbarHeight;
      let mapHeight = contentHeight;
      document.getElementById("helpId").style.height = mapHeight + "px";
      console.log("height:", mapHeight)
    }

  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.url=ConfigParams.API_URL + 'help'
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }

};
</script>

<style scoped>
.row {
  /* margin: 0px; */
}
.header-row {
  height: 100px;

}
.row-fluid {
  content: "";
  clear: both;
  display: table;
  line-height: 130%;
}

.chartLabel .stats {
  color: black;
}

.chartLabel {
  position: relative;
  width: 20%;
  padding: 20px;
  /* padding-bottom: 10px; */
  float: right;
  /* margin: -5px; */
  /* border-right: 2px solid;
   border-color: aliceblue; */
  margin-top: 0;
  padding-top: 0;
}

/* .chartArea {
  position: fixed;
  bottom: 0;
} */

#card-content {
  color: #d6d2c8;
  min-width: 240px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 1);
}

.card{
  color: gray!important;
  font-size: 1.1em;
  min-width: 240px;
  box-shadow: 0px 6px 10px 1px rgba(0, 0, 0, 0.5);
}
.card-title {

    float: right;
    position: absolute;
    right: 40px;
    text-align: right;
}

</style>
